import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class QrcodeRequest extends CrudRequest {
  static baseUrl() {
    return '/contacardcommon/qrcode';
  }

  static solicit(payload) {
    return httpService.post(
      '/reports/reports/qrcodes-control',
      payload,
    );
  }
}
